module.exports = "/_next/static/images/spot-165e6ada7dd5f7b9efd03764d4902955.svg";